import { render, staticRenderFns } from "./Cozinha.vue?vue&type=template&id=247cd914&scoped=true&"
import script from "./Cozinha.vue?vue&type=script&lang=js&"
export * from "./Cozinha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247cd914",
  null
  
)

export default component.exports